import React from 'react';
import { ArrowDown, Check, Circle, Terminal } from 'lucide-react';

export default function LandingWorkflowPreview() {
  return (
    <div className="relative mx-auto w-full max-w-lg">
      <div aria-hidden="true" className="absolute -inset-4 rounded-[2rem] bg-violet-100/60 sm:-rotate-3" />
      <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl shadow-slate-900/5">
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <span className="flex items-center gap-2 text-sm font-semibold text-slate-800">
            <Terminal size={17} className="text-violet-600" /> A test. From idea to insight.</span>
          <span className="text-[10px] font-medium uppercase tracking-widest text-slate-400">Example</span>
        </div>
        <div className="space-y-4 p-5 sm:p-7">
          <div>
            <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-violet-700">01 / Describe</p>
            <p className="rounded-xl border border-violet-100 bg-violet-50/60 p-4 text-sm leading-relaxed text-slate-700">“Check that the products endpoint returns 200 and every product has a name and price.”</p>
          </div>
          <ArrowDown size={15} className="mx-auto text-slate-300" aria-hidden="true" />
          <div>
            <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-violet-700">02 / Run</p>
            <div className="rounded-xl bg-slate-950 p-4 font-mono text-xs leading-7 text-slate-300">
              <p>
                <span className="mr-3 text-emerald-400">GET</span>/api/products</p>
              <p className="flex items-center gap-2">
                <Check size={12} className="text-emerald-400" /> Status equals 200</p>
              <p className="flex items-center gap-2">
                <Check size={12} className="text-emerald-400" /> Product fields are present</p>
            </div>
          </div>
          <ArrowDown size={15} className="mx-auto text-slate-300" aria-hidden="true" />
          <div className="flex items-center justify-between gap-3 rounded-xl border border-emerald-100 bg-emerald-50/70 p-4">
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-widest text-emerald-700">03 / Understand</p>
              <p className="mt-1 text-sm font-semibold text-slate-800">Know what passed. See what needs work.</p>
            </div>
            <Circle size={21} className="shrink-0 fill-emerald-500 text-emerald-500" aria-hidden="true" />
          </div>
        </div>
        <p className="border-t border-slate-100 px-5 py-3 text-[11px] text-slate-400">Illustrative workflow · Your tests, your application.</p>
      </div>
    </div>
  );
}
